import React, { useEffect, useState } from 'react';
import { Checkbox, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import axiosInstance from '../variables/api/axiosInstance';
import { can, HAB, getUser } from '../variables/constants';

/**
 * « Apposer ma signature » - le dernier mot revient au responsable.
 *
 * POURQUOI CE CHOIX EXISTE. Le paramétrage dit qu'un document porte une signature ;
 * il ne peut pas savoir que CE tirage-là n'en veut pas - un brouillon relu en réunion,
 * une copie de travail, un document que le responsable veut signer à la main devant
 * son interlocuteur. La case est cochée selon le paramétrage, et se décoche.
 *
 * POURQUOI ELLE NE S'AFFICHE PAS POUR TOUT LE MONDE. Elle n'apparaît qu'à qui détient
 * SIGNATURE_APPOSER **et** occupe la fonction qui signe ce document. Un rédacteur qui
 * imprime une fiche signée du Secrétaire Exécutif n'a pas à décider si le Secrétaire
 * Exécutif signe : ce n'est pas sa signature. La lui proposer laisserait croire que
 * la décision lui revient.
 *
 * L'appelant décide quoi faire de l'état : le passer à BlocSignature en `actif`.
 */
export default function CaseApposerSignature({ codeDocument, valeur, onChange }) {
  const { t } = useTranslation('commun');
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!can(HAB.SIGNATURE_APPOSER)) { setVisible(false); return undefined; }

    let ignore = false;
    axiosInstance
      .get('/v1/parametres/signatures-documents', { skipErrorToast: true })
      .then((r) => {
        if (ignore) return;
        const ligne = (r.data?.data || []).find((l) => l.codeDocument === codeDocument);
        const user = getUser();
        /* Occuper la fonction, ce n'est pas porter le profil : le paramétrage peut
           avoir désigné un titulaire parmi plusieurs porteurs. On compare donc à
           l'identifiant qu'il a résolu, qui est la seule réponse qui fasse foi. */
        const cestMoi = !!ligne?.titulaireTrackingId
          && ligne.titulaireTrackingId === user?.utilisateurTrackingId;

        const proposable = !!ligne?.signatureRequise && cestMoi && !!ligne?.signatureDisponible;
        setVisible(proposable);
        // Cochée par défaut selon le paramétrage : le cas courant est de signer.
        if (proposable) onChange?.(true);
      })
      .catch(() => { if (!ignore) setVisible(false); });

    return () => { ignore = true; };
    // onChange n'est pas dans les dépendances : une fonction recréée à chaque rendu
    // relancerait l'appel en boucle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codeDocument]);

  if (!visible) return null;

  return (
    <Tooltip title={t('caseApposerSignature.aide')}>
      <Checkbox
        checked={valeur}
        onChange={(e) => onChange?.(e.target.checked)}
        style={{ fontSize: 13 }}
      >
        {t('caseApposerSignature.libelle')}
      </Checkbox>
    </Tooltip>
  );
}
